<div style="display: flex">
    <p-dialog *ngIf="displayEventDialog == true" header="Add Calendar Event" visible="true" [maximizable]="false" [closable]="false"
        [closeOnEscape]="false">
        <div class="flex items-center mb-3 mt-2">
            <label>Event Color: </label>
            <p-colorPicker styleClass="w-full ml-2" class="dialog-colorpicker" format="hex" appendTo="body"
                [(ngModel)]="color">
            </p-colorPicker>
        </div>
        <p-floatLabel variant="on" class="mb-3">
            <p-select styleClass="w-full" [options]="eventTypesSelectItem" [filter]="true" appendTo="body"
                [autoDisplayFirst]="false" [(ngModel)]="eventType">
            </p-select>
            <label>Type</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-3">
            <p-calendar styleClass="w-full" appendTo="body" [(ngModel)]="selectedCalendarDate" [yearNavigator]="true"
                [monthNavigator]="true" yearRange="2010:2030">
            </p-calendar>
            <label for="float-dd">End Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-3">
            <textarea class="w-full" rows="5" cols="30" pInputTextarea autoResize="autoResize"
                [(ngModel)]="description"></textarea>
            <label for="float-dd">Description</label>
        </p-floatLabel>

        <ng-template #footer>
            <button type="button" pButton class="p-button-text p-button-success"
                (click)="confirmDialog()" label="Confirm"></button>
            <button type="button" pButton class="p-button-text p-button-danger" (click)="cancelDialog()" label="Cancel"></button>
        </ng-template>
        <!-- <form [formGroup]="eventFormGroup" #eventForm="ngForm" id="eventForm">
            <label>Color</label>
            <div style="margin-bottom: 1em;">
                <p-colorPicker class="dialog-colorpicker" format="hex" appendTo="body" formControlName="color">
                </p-colorPicker>
            </div>

            <label>Type</label>
            <div style="margin-bottom: 1em;">
                <p-dropdown [options]="eventTypesSelectItem" [filter]="true" appendTo="body" [autoDisplayFirst]="false"
                    placeholder="Type" formControlName="type">
                </p-dropdown>
            </div>

            <label for="float-dd">Date</label>
            <div style="margin-bottom: 1em">
                <p-calendar appendTo="body" formControlName="endDate" [yearNavigator]="true"
                [monthNavigator]="true"
                yearRange="2010:2030">
                </p-calendar>
            </div>

            <label for="float-dd">Description</label>
            <div style="margin-bottom: 1em">
                <textarea rows="5" cols="30" pInputTextarea autoResize="autoResize"
                    formControlName="description"></textarea>
            </div>


        </form> -->

        <!-- <ng-template #footer >
            <button type="button" pButton class="p-button-text p-button-success" icon="pi pi-check"
                (click)="confirmDialog()" label="Confirm"></button>
            <button type="button" pButton class="p-button-text p-button-danger" (click)="cancelDialog()"
                icon="pi pi-times" label="Cancel"></button>
        </ng-template> -->
    </p-dialog>
</div>
<div class="card">
    <div style="display: flex">
        <p-dialog header="Choose a display color for each date type" [(visible)]="displayColorOptions"
            [maximizable]="false" [closable]="false" [closeOnEscape]="false">

            <form [formGroup]="multiUpdateFormGroup" #eventForm="ngForm" id="multiForm">
                <p-toolbar>
                    <span class="p-float-label">
                        <p-dropdown [options]="eventTypesMultiSelectItem" [filter]="true" appendTo="body"
                            [autoDisplayFirst]="false" placeholder="Date Type" formControlName="multi_type">
                        </p-dropdown>
                        <label for="float-dd">Date Type</label>
                    </span>

                    <span class="p-float-label">
                        <p-colorPicker class="multi-colorpicker" format="hex" appendTo="body"
                            formControlName="multi_color">
                        </p-colorPicker>
                        <label *ngIf="this.multiUpdateFormGroup.controls['multi_color'].value != null" for="float-dd"
                            [style.color]="this.labelTextColor">
                            {{
                            this.multiUpdateFormGroup.controls["multi_color"].value
                            }}
                        </label>
                        <label style="top: -.8rem; font-size: 12px;">
                            Select a Color
                        </label>
                    </span>

                    <!-- <button type="button" pButton class="p-button-secondary" icon="pi pi-check" label="Apply" (click)="colorMultiUpdate()"></button> -->
                </p-toolbar>
            </form>

            <ng-template #footer>
                <button type="button" pButton class="p-button-text p-button-success" icon="pi pi-check"
                    (click)="colorMultiUpdate()" label="Confirm"></button>
                <button type="button" pButton class="p-button-text p-button-danger"
                    (click)="displayColorOptions = false" icon="pi pi-times" label="Cancel"></button>
            </ng-template>
        </p-dialog>
    </div>

    <div class="button-bar" style="padding-bottom: 0 !important; width: 50%;">
        <strong *ngIf="this.IsAdministrator">Click calendar date to add a custom date</strong>
        <button *ngIf="this.IsAdministrator" pButton type="button" class="p-button-text"
            (click)="displayColorOptions = true" label="Assign Calendar Event Color"></button>
    </div>
    <div class="grid">
        <div class="col-6 grid">
            <div class="col-12">
                <ef-fullcalendar
                    #calendar
                    id="companyCalendar"
                    [events]="events"
                    [options]="options"
                    (select)="datesSelected($event)"
                    (eventClick)="eventSelected($event)"
                    (datesRender)="datesRender($event)"
                    (eventRender)="eventRender($event)"
                ></ef-fullcalendar>
            </div>
            <!-- <div class="col-12">
                <p-card header="Add Calendar Event">
                    <div class="flex items-center mb-3">
                        <label>Event Color: </label>
                        <p-colorPicker styleClass="w-full ml-2" class="dialog-colorpicker" format="hex" appendTo="body"
                            [(ngModel)]="color">
                        </p-colorPicker>
                    </div>
                    <p-floatLabel variant="on" class="mb-3">
                        <p-dropdown styleClass="w-full" [options]="eventTypesSelectItem" [filter]="true" appendTo="body"
                            [autoDisplayFirst]="false" [(ngModel)]="eventType">
                        </p-dropdown>
                        <label>Type</label>
                    </p-floatLabel>
                    <p-floatLabel variant="on" class="mb-3">
                        <p-calendar styleClass="w-full" appendTo="body" [(ngModel)]="endDate" [yearNavigator]="true"
                            [monthNavigator]="true" yearRange="2010:2030">
                        </p-calendar>
                        <label for="float-dd">End Date</label>
                    </p-floatLabel>
                    <p-floatLabel variant="on" class="mb-3">
                        <textarea class="w-full" rows="5" cols="30" pInputTextarea autoResize="autoResize"
                            [(ngModel)]="description"></textarea>
                        <label for="float-dd">Description</label>
                    </p-floatLabel>

                    <ng-template #footer>
                        <button type="button" pButton class="p-button-text p-button-success" icon="pi pi-check"
                            (click)="confirmDialog()" label="Confirm"></button>
                        <button type="button" pButton class="p-button-text p-button-danger" (click)="cancelDialog()"
                            icon="pi pi-times" label="Cancel"></button>
                    </ng-template>
                </p-card>
            </div>             -->
        </div>
        <div class="col-6">
            <div class="flex items-center">
                <p-checkbox inputId="label" #chkShowAllDates class="ef-checkbox" binary="true" data-toggle="tooltip"
                    data-placement="top" [title]="cbxLabel" (onChange)="showAllDates($event)"
                    [(ngModel)]="cbxValue"></p-checkbox>
                <label for="label" class="ml-2"> {{ cbxLabel }} </label>
            </div>

            <p-table stripedRows #CCTable [style]="{'min-width': '45em'}" [value]="companyDates" scrollHeight="65vh"
                editMode="row" (onEditInit)="onEditInit($event)" (onRowEditSave)="onRowEditSave($event)" dataKey="id">

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="17" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #header>
                    <tr>
                        <th class="status-cell">
                            <i class="pi pi-exclamation-circle" title="Status"></i>
                        </th>
                        <th *ngIf="this.IsAdministrator" class="edit-cell"></th>
                        <!-- <th  pSortableColumn="ScheduledStartDate" class="tabulator-colgroup-header">
                        <div class="tabulator-col-content">
                            Start Date
                            <p-sortIcon field="ScheduledStartDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </div>
                    </th> -->
                        <th pSortableColumn="ScheduledEndDate" class="small-cell">
                            Date
                            <p-sortIcon field="ScheduledEndDate" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="ScheduledDatePurpose" class="large-cell">
                            Description
                            <p-sortIcon field="ScheduledDatePurpose" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="ScheduledDatePurpose" matchMode="in" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect class="filter" defaultLabel="Filter"
                                        [options]="eventDescFilterSelectItem" [filter]="true" appendTo="body"
                                        [ngModel]="value" (ngModelChange)="filter($event)" styleClass="w-full">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>

                        <th pSortableColumn="ScheduledDateType" class="small-cell">
                            Type
                            <p-sortIcon field="ScheduledDateType" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <p-columnFilter field="ScheduledDateType" matchMode="in" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                <ng-template #filter let-value let-filter="filterCallback">
                                    <p-multiSelect class="filter" defaultLabel="Filter"
                                        [options]="eventTypesFilterSelectItem" [filter]="false" appendTo="body"
                                        [ngModel]="value" (ngModelChange)="filter($event)" styleClass="w-full">
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </th>

                        <th pSortableColumn="DateColor" class="small-cell">
                            Color
                            <p-sortIcon field="DateColor" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                        </th>
                        <th *ngIf="this.IsAdministrator" class="tiny-cell">
                            Delete
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-date let-edit="editing" let-ri="rowIndex">
                    <tr [pSelectableRow]="date" [pEditableRow]="date" data-id="row-{{ date.ScheduledDateID }}">
                        <td class="status-cell">
                            <div style="height: 2em; align-self: center">
                                <a (click)="
                                ShowError.next(date)
                            ">
                                    <div>
                                        <ef-status-icon [status]="
                                date?.Status
                                            ?.StatusCode
                                    " [message]="
                                    date?.Status
                                            ?.Message
                                    "></ef-status-icon>
                                    </div>
                                </a>
                            </div>
                        </td>
                        <td *ngIf="this.IsAdministrator" class="edit-cell"
                            style="text-align: center; align-items: center">
                            <button *ngIf="!edit && (!editing?.id || !editing?.id === date?.id)" pButton pRipple
                                type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(date)"
                                class="p-button-rounded p-button-text" style="height: 1.4rem; width: 1.4rem;"
                                title="Edit">
                            </button>
                            <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                (click)="onRowEditSave(date)" class="p-button-rounded p-button-text p-button-success"
                                style="margin-right: 0.5em;height: 1.4rem;width: 1.4rem;">
                            </button>
                            <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(date)" class="p-button-rounded p-button-text p-button-danger"
                                style="height: 1.4rem; width: 1.4rem">
                            </button>
                        </td>
                        <!-- <td class="p-datatable-cell">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div *ngIf="date.ScheduledDateType == 'HOL' || date.ScheduledDateType == 'GEN'">
                                    <p-calendar appendTo="body" [(ngModel)]="date.ScheduledStartDate"></p-calendar>
                                </div>
                                <span *ngIf="date.ScheduledStartDate != null && date.ScheduledDateType == 'PPE'">
                                    {{ moment(date.ScheduledStartDate).format("MM/DD/YYYY") }}
                                </span>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span *ngIf="date.ScheduledStartDate != null">
                                    {{ moment(date.ScheduledStartDate).format("MM/DD/YYYY") }}
                                </span>
                            </ng-template>
                        </p-cellEditor>
                    </td> -->
                        <td class="small-cell">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <div *ngIf="date.ScheduledDateType == 'HOL' || date.ScheduledDateType == 'GEN'">
                                        <p-calendar appendTo="body" [(ngModel)]="date.ScheduledEndDate"
                                            (onSelect)="endDateSelected($event)" [yearNavigator]="true"
                                            [monthNavigator]="true" yearRange="2010:2030"></p-calendar>
                                    </div>
                                    <span
                                        *ngIf="date.ScheduledEndDate != null && date.ScheduledDateType == 'PPE' || date.ScheduledEndDate != null && date.ScheduledDateType == 'Leave' || date.ScheduledEndDate != null && date.ScheduledDateType == 'FYE'">
                                        {{ moment(date.ScheduledEndDate).format("MM/DD/YYYY") }}
                                    </span>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span *ngIf="date.ScheduledEndDate != null">
                                        {{ moment(date.ScheduledEndDate).format("MM/DD/YYYY") }}
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td class="large-cell">
                            {{ date.ScheduledDatePurpose }}
                        </td>
                        <td class="small-cell">
                            {{ date.ScheduledDateType }}
                        </td>
                        <td class="small-cell">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <div>
                                        <p-colorPicker [(ngModel)]="date.DateColor" format="hex" appendTo="body"
                                            *ngIf="date.ScheduledDateType != 'Leave'"></p-colorPicker>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    <span class="p-float-label">
                                        <p-colorPicker *ngIf="date.DateColor != null" class="display-colorpicker"
                                            [(ngModel)]="date.DateColor" format="hex" appendTo="body" [disabled]="true">
                                        </p-colorPicker>
                                        <label *ngIf="date.DateColor != null" for="float-dd"
                                            [style.color]="setTextColor(date.DateColor)">
                                            {{
                                            date.DateColor
                                            }}
                                        </label>
                                    </span>
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="this.IsAdministrator" class="tiny-cell"
                            style="text-align: center; align-items: center">
                            <button *ngIf="date.ScheduledDateType == 'HOL' || date.ScheduledDateType == 'GEN'" pButton
                                type="button" class="btn btn-link" (click)="onCompanyDateDelete(date)"
                                icon="pi pi-trash" class="p-button-danger p-button-rounded p-button-text"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
